import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var CurrentUser = require("lib/account/CurrentUser");
var ReactTooltip = require("react-tooltip");
var Modal = require("components/utility/AltModal");
var Spinner = require("components/utility/Spinner");
var StudentListDropdownDisplay = require("components/org/StudentListDropdownDisplay");
var LoadingButton = require("components/utility/LoadingButton");
var StudentDisplay = require("components/users/students/StudentDisplay");
var RosterRouting = require("lib/routing/RosterRouting");
var RosterSelectors = require('lib/selectors/RosterSelectors');
var Glyphicon = require("components/utility/icons/Glyphicon");
var StudentMetrics = require("lib/data/StudentMetrics");

var AccountPlans = require("lib/account/AccountPlans");
var CurrentUser = require("lib/account/CurrentUser");
var OrgTypes = require("lib/academic/OrgTypes");
var OrgDropdown = require("components/org/OrgDropdown");

var RosterActions = require("lib/actions/RosterActions");
var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var Features = require("lib/account/Features");
require("writing/tasks/assign_task_modal.scss");

@connect(
	(state, props) => ({
		tasks: WritingSelectors.teacherPicksTasks({ state: state, filters: { assigner_id: CurrentUser.get().id } }),
		exerciseTasks: WritingSelectors.tasks({ state: state, filters: { subject_type: 'exercise', assigner_id: CurrentUser.get().id } }),
		initialSelectedStudentIDs: WritingSelectors.userIDsByTaskSubjectID({
			state, filters: {
				subject_type: props.taskSubjectType,
				subject_id: props.taskSubjectID + ""
			},
		})[props.taskSubjectID],

		getStudents: (orgIdentifier) => {
			return RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier: orgIdentifier })
		},
		loading: (RosterSelectors.isLoadingStudents({ state, key: 'index'}) || RosterSelectors.isLoadingStudentLists({ state, key: 'index'}))
	}),

	(dispatch, props) => ({
		deleteManyTasks: (userIDs) => {
			// Delete all tasks
			return dispatch(WritingActions.deleteManyTasks({
				filters: {
					subject_type: props.taskSubjectType,
					subject_id: props.taskSubjectID + ""
				},
				conditions: {
					oneOfMatch: { user_id: userIDs }
				}
			}));
		},
		addStudentsToTaskAssignment: (userIDs) => {
			var query = {}
			var tasks = _.map(userIDs, (studentID) => {
				return {
					user_id: studentID,
					assigner_id: CurrentUser.get().id, 
					subject_type: props.taskSubjectType,
					subject_id: props.taskSubjectID
				};				
			});
			if (props.textToAssign && props.textToAssign.taskItems) {
				_.each(props.textToAssign.taskItems, item => {
					query = {
						task_items: {
							quiz: _.where(item, { subject_type: 'Quiz' }).length ? true : false,
							practice_questions: _.where(item, { subject_type: 'Practice Question' }).length ? _.where(item, { subject_type: 'Practice Question' }).length : 0,
							review: _.where(item, { subject_type: 'Review' }).length ? true : false,
							due_date_enabled: _.first(item).due_date ? true : false,
							due_date: _.first(item).due_date,
							exercises: _.where(item, { subject_type: 'Exercise' }).length ? _.where(item, { subject_type: 'Exercise' }).length : 0,
						}
					}
				})
			}
			if (tasks.length) {
				return dispatch(WritingActions.createTasks({ tasks, query }));
			} else {
				return Promise.resolve();
			}
		},
		populateData: () => {
			var fetchStudents = function() {
				// Loads in stuff we need but didn't get from the loading on App.js
				var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS
				return dispatch(RosterActions.fetchStudents({ embeds }));
			}

			var fetchStudentLists = function() {
				// Loads in stuff we need but didn't get from the loading on App.js
				var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS
				return dispatch(RosterActions.fetchStudentLists({ embeds }));
			}

			return Promise.all([
				fetchStudentLists().then( slResponse => {
					return fetchStudents()
				})
			])
		}
		

		
	})
)

@providePopulateData()
class AssignTaskModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var selectedStudentIDs = _.clone(props.initialSelectedStudentIDs || []);
		selectedStudentIDs = _.map(selectedStudentIDs, (id) => { return parseInt(id) });

		var bookTasks = _.filter(props.tasks, (task) => { return task.subject_id === props.taskSubjectID }) || []

		var allTaskItems = _.collect(_.flatten(_.uniq(_.pluck(props.tasks, 'task_items'))))

		this.state = {
			bookTasks: bookTasks,
			selectedStudentIDs,
			allTaskItems,
			selectedOrgIdentifier: OrgTypes.ALL_STUDENTS_IDENTIFIER,
			loading: false
		};
	}
	// paywall helper method
	allowAccess() {
		var user = CurrentUser.get();
		var activeTrials = user.account.active_trials
		var hasQualifiedTrial = activeTrials && (activeTrials[AccountPlans.PRODUCTS.WR_GOLD] || activeTrials[AccountPlans.PRODUCTS.WR_SILVER]) ? true : false
		return (user.product === "wrSilver" || user.product === "wrGold" || hasQualifiedTrial) ? true : false
	}

	showDeselectAll() {
		return this.students().length == this.state.selectedStudentIDs.length;
	}

	deselectAll() {
		this.setState({ selectedStudentIDs: [] });
	}

	selectAll() {
		this.setState({ selectedStudentIDs: _.pluck(this.students(), "id") });
	}

	getSubjectName() {
		if (this.props.taskSubjectType == EXERCISE) {
			return "Exercise";
		} else if (this.props.taskSubjectType == URLPICK) {
			return "URL";
		} else if (this.props.taskSubjectType == TITLEPICK) {
			return "Title";
		} else {
			console.error("Unknown taskSubjectType " + this.props.taskSubjectType)
		}
	}

	students() {
		var students = this.props.getStudents(this.state.selectedOrgIdentifier)
		return $wr.sortByName(students, "flexName");
	}

	onOrgSelect(identifier) {
		var students = this.props.getStudents(identifier);
		var studentIDs = _.pluck(students, "id");
		this.setState({ selectedOrgIdentifier: identifier, selectedStudentIDs: [] });
	}

	toggleStudentSelect(studentID) {
		studentID = parseInt(studentID)
		var selectedStudentIDs = this.state.selectedStudentIDs;
		var studentIndex = selectedStudentIDs.indexOf(studentID);
		if (studentIndex > -1) {
			selectedStudentIDs.splice(studentIndex, 1);
		} else {
			selectedStudentIDs.push(studentID);
		}
		this.setState({ selectedStudentIDs });
	}
	// returns all new users added to assignment
	newUsers() {
		return this.props.initialSelectedStudentIDs ? this.state.selectedStudentIDs.filter((obj) => { return this.props.initialSelectedStudentIDs.indexOf(obj) == -1; }) : this.state.selectedStudentIDs
	}
	// returns all users removed from assignment
	removedUsers() {
		return this.props.initialSelectedStudentIDs ? this.props.initialSelectedStudentIDs.filter((obj) => { return this.state.selectedStudentIDs.indexOf(obj) == -1; }) : []
	}
	// add and/or removes students from task assignment
	updateTaskAssignment() {
		var newUsers = this.newUsers();
		var removedUsers = this.removedUsers();

		if (this.props.initialSelectedStudentIDs || !this.allowAccess()) {
			var renderAdditionalModal = false
		} else {
			var renderAdditionalModal = true
		}

		if (renderAdditionalModal) {
			this.successBannerTrigger(this.state.selectedStudentIDs, renderAdditionalModal);
		} else {
			this.props.deleteManyTasks(removedUsers);
			this.props.addStudentsToTaskAssignment(newUsers).then(() => {
				this.successBannerTrigger(this.state.selectedStudentIDs, renderAdditionalModal);
			});
		}
	}

	submitTasks(e) {
		$wr.nope(e)
		this.setState({ loading: true });
		this.updateTaskAssignment()
	}

	successBannerTrigger(selectedStudents, additonalModal) {
		additonalModal = additonalModal === null ? false : additonalModal;
		
		if (selectedStudents && selectedStudents.length > 1) {
			var text = "Your students have been assigned " + this.props.selectedActivityTitle + ".";
		} else {
			var text = "Your student has been assigned " + this.props.selectedActivityTitle + ".";
		}

		this.setState({ loading: false, selectedStudentIDs: [] }, () => {
			if (!additonalModal) {
				var title = "Assigned " + this.getSubjectName();
				window.wrNotifications.triggerDropDownNotification({
					title: title, text: text, icon: "ok-sign"
				});
			}
			this.props.onAssign(selectedStudents, additonalModal);
		});
	}

	renderControls() {
		if (this.showDeselectAll()) {
			var selectLink = (
				<button className="btn btn-link" onClick={ this.deselectAll }>
					Clear All
				</button>
			);
		} else {
			var selectLink = (
				<button className="btn btn-link" onClick={ this.selectAll }>
					Select All
				</button>
			);
		}
		var button = (this.containsStudents() && this.students().length > 50) ? this.renderButton() : ''

		return (
			<span className="controls">
				{ selectLink }
				{ button }
			</span>
		)
	}

	renderLoadingState() {
		if (this.props.loading || this.state.loading) {
			return (
				<div>
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			)
		}
		return ""
	}

	containsStudents()  {
		return (this.state.selectedStudentIDs && this.state.selectedStudentIDs.length > 0) || (this.props.initialSelectedStudentIDs && this.props.initialSelectedStudentIDs.length > 0);
	}

	findTask(studentID) {
		return _.find(this.props.tasks, { user_id: studentID, subject_id: this.props.taskSubjectID, subject_type: this.props.taskSubjectType }) || _.find(this.state.allTaskItems, { user_id: studentID, subject_id: this.props.taskSubjectID, subject_type: this.props.taskSubjectType })
	}

	findStandAloneExercise(studentID) { 
		return _.find(this.props.exerciseTasks, { user_id: studentID, subject_id: String(this.props.taskSubjectID), subject_type: 'exercise' })
	}

	isFinishedStudent(studentID) {
		var task = this.findTask(studentID)
		var standAloneExercise = this.findStandAloneExercise(studentID)
		if (task && task.task_items) {
			var taskItems = task.task_items

			var finishedQuiz = _.where(taskItems, { subject_type: 'quiz', draft: false }) || [];
			var finishedPracticeQuestions = _.where(taskItems, { subject_type: 'practice question', draft: false }) || [];
			var finishedReview = _.where(taskItems, { subject_type: 'review', draft: false }) || [];
			var finishedExercise = _.where(taskItems, { subject_type: 'exercise', draft: false }) || [];
			// sum completed tasks
			var completed_tasks = finishedQuiz.length + finishedPracticeQuestions.length + finishedReview.length + finishedExercise.length
			// return comparison
			return taskItems.length <= completed_tasks ? true : false;
		} else if (task) {
			return !task.draft
		} else if (standAloneExercise) {
			return !standAloneExercise.draft
		} else {
			return false;
		}
	}

	renderStudentStats(studentID) {
		var out = ''
		var task = this.findTask(studentID)
		if (_.size(task) && task.task_items) {
			// render quiz status
			var assignedQuiz = _.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ })
			if (_.size(assignedQuiz)) {
				var finishedQuiz = _.where(assignedQuiz, { draft: false })
				if (finishedQuiz.length) {
					out = out + `<span>Quiz Complete</span></br>`
				} else {
					out = out + `<span>Quiz Incomplete</span></br>`
				}
			}
			// render practice question status
			var assignedPracticeQuestions = _.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION })
			if (_.size(assignedPracticeQuestions)) {
				var finishedPracticeQuestions = _.where(assignedPracticeQuestions, { draft: false })
				out = out + `<span>${_.size(finishedPracticeQuestions)}/${_.size(assignedPracticeQuestions)} Questions</span></br>`
			}
			// render review status
			var assignedReview = _.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW })
			if (_.size(assignedReview)) {
				var finishedReview = _.where(assignedReview, { draft: false })
				if (finishedReview.length) {
					out = out + `<span>Review Complete</span></br>`
				} else {
					out = out + `<span>Review Incomplete</span></br>`
				}
			}
			// render exercise status
			var assignedExercises = _.where(task.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE })
			if (_.size(assignedExercises)) {
				var finishedExercises = _.where(assignedExercises, { draft: false })
				out = out + `<span>${_.size(finishedExercises)}/${_.size(assignedExercises)} Exercises</span></br>`
			}
		}
		return out
	}

 hasSubArray(master, sub) {
	 return sub.every((i => v => i = master.indexOf(v, i) + 1)(0));
 }
	// returns button with relevant text
	renderButton() {
		var buttonText = "Next"
		var buttonValue = "Next";
		if (this.props.initialSelectedStudentIDs) {
			buttonText = "Update";
			buttonValue = "Update";
			if (this.newUsers().length) {
				buttonText = "Assign";
				buttonValue = "Assign";
			} else if(this.removedUsers().length){
				buttonText = "Unassign " + this.getSubjectName();
				buttonValue = "Unassign";
			}
		} else if (!this.allowAccess()) {
			buttonText = "Assign";
			buttonValue = "Assign";
		}
		return (
			<LoadingButton className={"btn buttonSuccess center-block " + buttonValue}
				value={buttonValue} loading={this.state.loading} text={buttonText}
				onClick={this.submitTasks} />
		)
	}

	render() {
		var studentSelectorList = _.map(this.students(), function (student) {
			var studentID = student.id;
			var show_icon = false;

			if (_.contains(this.state.selectedStudentIDs, studentID)) {
				var className = " selectedStudent";
				if (this.allowAccess()) {
					show_icon = true;
					var iconColor = 'gray';
					if (this.isFinishedStudent(studentID)) {
						iconColor = 'green'
					}
				}
			}

			var studentTaskStats = ''
			if (show_icon && this.state[studentID] && this.renderStudentStats(studentID).length) {
				studentTaskStats = (
					<div className='studentTaskStats'>
						{this.renderStudentStats(studentID)}
					</div>
				)
			}

			var icon = ''
			if (show_icon) {
				icon = (
					<Glyphicon icon='glyphicon glyphicon-check'
						style={{ color: iconColor, top: '9px', margin: '0 0 0 10px', fontSize: '20px' }} />
				)
			}

			return (
				<div key={studentID} data-tip={this.renderStudentStats(studentID)} className={ "studentDisplayWrap " + className }
					onClick={ this.toggleStudentSelect.bind(this, studentID) }>
					<StudentDisplay studentID={studentID} showAvatar avatarMaxWidth={50} />
					{ icon }
					{ studentTaskStats}
					<ReactTooltip effect="solid" html={true} />
				</div>
			);
		}.bind(this));

		var selector = (
			<OrgDropdown dropdownDisplay="link" 
				selectedIdentifier={ this.state.selectedOrgIdentifier }
				onSelect={ this.onOrgSelect }  />
		);
		var button = this.containsStudents() ? this.renderButton() : ''
		var loading = this.renderLoadingState()

		if (loading) {
			var modalContent = loading	
		} else {
			var modalContent = (
				<div>
					{this.renderLoadingState()}
					{selector}
					{this.renderControls()}
					<div className="studentOptions">
						{studentSelectorList}
					</div>
					{button}
				</div>
			);
		}

		return (
			<div className="assignTaskModal">
				{ modalContent }
			</div>
		)
	}
};

var EXERCISE = 'exercise'
var URLPICK = 'URLPick'
var TITLEPICK = 'TitlePick'

AssignTaskModal.WrappedComponent.propTypes = StrictPropTypes({
	tasks: PropTypes.array,

	// ID of the task we're assigning
	taskSubjectID: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]).isRequired,

	onAssign: PropTypes.func,
	renderAdditionalModal: PropTypes.bool,
	// subject type of the task we are assigning
	taskSubjectType: PropTypes.string.isRequired,

	// From @connect

	initialSelectedStudentIDs: PropTypes.array,
	textToAssign: PropTypes.object,
	selectedActivityTitle: PropTypes.string,
	getStudents: PropTypes.func,
	deleteManyTasks: PropTypes.func,
	addStudentsToTaskAssignment: PropTypes.func,

});

module.exports = AssignTaskModal;



// WEBPACK FOOTER //
// ./modules/components/writing/tasks/AssignTaskModal.js